import React, { useEffect } from 'react';
import EcoSection from 'eco-design/base/eco-section';
import style from './index.module.scss';
import { useLang } from '@/i18n';

interface Props {}

const Screen1: React.FC<Props> = ({}) => {
    const { t } = useLang('theProduct.Screen1');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const IS_Pad = window.innerWidth <= 1024 && window.innerWidth >= 768;
            const IS_H5 = window.innerWidth < 768;

            let marginLeft = -257;
            switch (true) {
                case IS_Pad:
                    marginLeft = -210;
                    break;
                case IS_H5:
                    marginLeft = -120;
                    break;
            }
            const screen = AniContainer.create({
                triggerElement: '.page-product .Screen1',
                triggerHook: 0,
                asyncFromTo: [
                    ['.Screen1 .screen1-background', { marginLeft: 0 }, { marginLeft }, 0.8],
                    ['.Screen1 .screen1-section', { opacity: 0 }, { opacity: 1 }, 0.4],
                    ['.Screen1 .screen1-section', { opacity: 1 }, { opacity: 1 }, 0.1],
                    ['.Screen1 .screen1-background', { marginLeft }, { marginLeft }, 0.1],
                ],
                duration: '100%',
                asyncTimeLine: [0.2, 0.6, 1, 1],
            });

            return () => {
                screen && screen.destroy();
            };
        }
    }, []);

    return (
        <div className={`Screen1 GtmModuleData-section ${style.comp}`} data-section-id="Screen1">
            <img className="screen1-background " src="https://websiteoss.ecoflow.com/upload/image/1747906171332/shou.png" loading="lazy" />
            <div className="screen1-content">
                <EcoSection
                    className="screen1-section"
                    title={t.rich('title', {
                        s: (v: string) => <span>{v}</span>,
                    })}
                    desc={t('desc')}
                />
            </div>
            {/* 用于锚点定位 */}
            <div className="temp-Screen1-content" id="Screen1-content"></div>
        </div>
    );
};
export default Screen1;
